// extracted by mini-css-extract-plugin
module.exports = {"fichas":"Consultar_fichas__1Vqg4"};